// src/pages/Chat/TypingIndicator.jsx
//
// FIX: `s.typingUsers[convId]` returned undefined when no one is typing,
// and callers did `Object.values(undefined)` → crash. Also, returning a
// new `{}` fallback in the selector creates a new reference every render
// → infinite loop.
//
// FIX: Use EMPTY_OBJECT sentinel from chatStore so the fallback is always
// the same reference.

import React from "react";
import useChatStore, { EMPTY_OBJECT } from "../../store/chatStore";

export default function TypingIndicator() {
  const selectedConvId = useChatStore((s) => s.selectedConvId);

  // ✅ FIXED: use stable EMPTY_OBJECT sentinel, never `|| {}` or `|| []`
  const typingMap = useChatStore((s) =>
    selectedConvId
      ? (s.typingUsers[selectedConvId] ?? EMPTY_OBJECT)
      : EMPTY_OBJECT
  );

  const names = Object.values(typingMap);
  if (names.length === 0) return null;

  const label =
    names.length === 1
      ? `${names[0]} is typing`
      : names.length === 2
      ? `${names[0]} and ${names[1]} are typing`
      : `${names[0]} and ${names.length - 1} others are typing`;

  return (
    <div className="flex items-center gap-2 px-4 py-1 text-xs text-slate-400 select-none">
      <span className="flex items-center gap-0.5 h-4">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-slate-400 animate-bounce"
            style={{ animationDelay: `${i * 150}ms`, animationDuration: "900ms" }}
          />
        ))}
      </span>
      <span className="italic">{label}…</span>
    </div>
  );
}